import { createSelector } from 'reselect';

interface rootReducer extends types.redux.rootReducer {}

const getTranslations = (state: rootReducer, key: string) => state.translation[key];
const getLanguage = (state: rootReducer) => state.settings.language;

export const NO_TRANSLATIONS = 'No translation';

export const getTranslation = createSelector([getTranslations, getLanguage], (translation, lang) => {
	try {
		return translation[lang.toLowerCase()];
	} catch (error) {
		return NO_TRANSLATIONS;
	}
});
